import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {FolderTree} from '../../models/file.model';
import {DocumentsApiService} from '../../services/api/documents-api.service';
import {MemberService} from '../../services/member.service';
import {MemberModel} from '../../models/user.model';
import {
    NavigationTableRequestModel,
    NavigationTableResponseItemModel,
    NavigationTableResponseModel,
    PermissionResponseModel
} from '../../models/file-table.model';
import {ModalService} from '../../services/modal/modal.service';
import {AlertService} from '../../services/notify/alert.service';
import {HelpersService} from '../../services/helpers.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-documents-repo-structure',
    templateUrl: './documents-repo-structure.component.html',
    styleUrls: ['./documents-repo-structure.component.scss']
})
export class DocumentsRepoStructureComponent implements OnInit {
    @Input() profile: MemberModel;
    fullScreen = false;

    foldersTree: FolderTree[];
    foldersSlider = [];
    selectedFolder: any;

    collections: PermissionResponseModel[];
    collectionsPagination = new NavigationTableRequestModel();
    selectedCollection: NavigationTableResponseItemModel;

    files: PermissionResponseModel[];
    filesPagination = new NavigationTableRequestModel();
    selectedFile: NavigationTableResponseItemModel;
    dataForTable: NavigationTableResponseModel;

    selectedPermissionsItem: NavigationTableResponseItemModel;

    permissions = [
        {right: 'is_read_my_doc', title: this.translate.instant('DOCUMENTS.ACCESS.is_read_my_doc')},
        {right: 'is_read_all', title: this.translate.instant('DOCUMENTS.ACCESS.is_read_all')},
        {right: 'is_upload_file', title: this.translate.instant('DOCUMENTS.ACCESS.is_upload_file')},
        {right: 'is_create_folder', title: this.translate.instant('DOCUMENTS.ACCESS.is_create_folder')},
        {right: 'is_edit_signer', title: this.translate.instant('DOCUMENTS.ACCESS.is_edit_signer')},
        {right: 'is_locked_collection', title: this.translate.instant('DOCUMENTS.ACCESS.is_locked_collection')},
        {right: 'is_edit_settings', title: this.translate.instant('DOCUMENTS.ACCESS.is_edit_settings')},
        {right: 'is_read_approved_doc', title: this.translate.instant('DOCUMENTS.ACCESS.is_read_approved_doc')},
        {right: 'is_edit_approver', title: this.translate.instant('DOCUMENTS.ACCESS.is_edit_approver')},
        {right: 'is_edit_property', title: this.translate.instant('DOCUMENTS.ACCESS.is_edit_property')},
        {right: 'is_delete', title: this.translate.instant('DOCUMENTS.ACCESS.is_delete')},
    ];

    constructor(
        private docApi: DocumentsApiService,
        private memberService: MemberService,
        private alert: AlertService,
        public modalService: ModalService,
        public helper: HelpersService,
        public translate: TranslateService,
    ) {
    }

    ngOnInit(): void {
        if (!this.profile) {
            this.memberService.getCurrentMember().then((result: MemberModel) => {
                this.profile = result;
            });
        }

        this.docApi.getFoldersTree(this.profile.guid).subscribe({
            next: data => {
                this.foldersTree = data.tree;
            }, error: error => {
                this.alert.setAlert(error.message, 'blue');
            }
        });
    }

    selectFolder(folder: any, page?: number): void {
        this.collectionsPagination.id = folder.id;
        this.collectionsPagination.guid = this.profile.guid;
        this.files = undefined;
        this.selectedCollection = undefined;

        if (page) {
            this.collectionsPagination.current_page = page;
        } else {
            this.collectionsPagination.current_page = 1;
        }

        this.docApi.getFoldersAndFilesTable(this.collectionsPagination).subscribe({
            next: data => {
                this.selectedFolder = folder;
                this.collectionsPagination = data.pagination;
                this.collections = data.data as PermissionResponseModel[];
            }
        });
    }

    selectCollection(collection: NavigationTableResponseItemModel, page?: number): void {
        if (collection.type_str === 'folder') {
            this.foldersSlider[this.selectedFolder.id] = true;
            this.selectFolder(collection);
            return;
        }

        this.filesPagination.id = collection.id;
        this.filesPagination.guid = this.profile.guid;
        this.filesPagination.filter = 'collection';

        if (page) {
            this.filesPagination.current_page = page;
        } else {
            this.filesPagination.current_page = 1;
        }
        this.docApi.getCollectionTable(this.filesPagination).subscribe({
            next: res => {
                this.selectedCollection = collection;
                this.filesPagination = res.pagination;
                this.files = res.data as PermissionResponseModel[];

                const prepareData = (res.data as PermissionResponseModel[]).map(x => {
                    return x.file;
                });
                this.dataForTable = res;
                this.dataForTable.data = prepareData;
            }, error: () => {
                this.files = undefined;
            }
        });
    }

    selectFile(file: NavigationTableResponseItemModel, modal: TemplateRef<any>): void {
        this.selectedFile = file;
        this.modalService.openTemplateModal(modal, 'xl');
    }

    openPermissionsTemplate(item: NavigationTableResponseItemModel, modal: TemplateRef<any>, rights?: any): void {
        if (rights) {
            item.right = rights;
        }
        this.selectedPermissionsItem = item;
        this.modalService.openTemplateModal(modal);
    }
}
